import { OK } from 'http-status-codes'
import getAxiosInstance from '../../helpers/get_axios_instance'
import moment from 'moment'

class CuadroDeMandoCalado {
  getCamionesCaladosTotalExp () {
    console.log('obtener camiones calados')
    const orden = '{"orden": ["exportador"]}'
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_calado_aceptado_total_exportador_cereal?r=${orden}`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el listado total de camiones calados.')
      return data
    })
  };

  getCamionesCaladosTotalCalif () {
    const orden = '{"orden": ["cereal", "cereal_variedad"]}'
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_calado_aceptado_total_calificacion_cereal?r=${orden}`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el listado total de camiones calados.')
      return data
    })
  };

  getCamionesCaladosTotalPerito () {
    const orden = '{"orden": ["puesto_de_calado"]}'
    const axios = getAxiosInstance()
    const promise = axios.get(`/consulta_calado_aceptado_total_perito_calador?r=${orden}`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el listado total de camiones calados.')
      return data
    })
  };

  getHistogramaCaladoPuesto () {
    const orden = '"orden": ["puesto_de_calado"]}'
    const parametros = `{"clave":{"fecha":"${moment(Date.now()).format('DD-MM-YYYY')}"},` + orden
    const axios = getAxiosInstance()
    const promise = axios.get(`/histograma_analisis_calado_puesto_listado?r=${parametros}`)
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el listado total de camiones calados.')
      return data
    })
  };
}

export default CuadroDeMandoCalado
